<template>
    <div class="vx-row match-height">
      <div class="vx-col w-full">
        <vx-card class="mt-2">
          <vs-tabs vs-alignment="fixed" alignment="fixed">
            <vs-tab :label="$t('PreInvoiceWaitingForCargo')">
              <draft></draft>
            </vs-tab>
            <vs-tab :label="$t('PreInvoiceWaitingForProcess')">
              <proccessing></proccessing>
            </vs-tab>
            <vs-tab :label="$t('PreInvoiceProcessed')">
              <procced></procced>
            </vs-tab>
            <vs-tab :label="$t('PreInvoiceDelivered')">
              <delivered></delivered>
            </vs-tab>
            
            <!-- <vs-tab :label="$t('AllPreInvoice')">
              <allPreInvoice></allPreInvoice>
            </vs-tab> -->
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </template>
  <script>
  import procced from "./Procced.vue"
  import draft from "./DraftPreInvoice.vue"
  import proccessing from "./Processing.vue"
  import delivered from "./Delivered.vue"

  export default {
    components: {
      draft,
      procced,
      proccessing,
      delivered,
    },
  };
  </script>